import React from 'react';
import '../TermsAndConditions/TermsAndConditions.css';

const PrivacyPolicy = () => {
  return (
    <div className="terms-container">
      <div className="terms-content">
        <header className="terms-header">
          <h1>Privacy Policy</h1>
          <p>How we safeguard your personal information and flight booking data</p>
        </header>

        <div className="terms-body">
          <p>
            At Click4Flight, we are deeply committed to protecting your privacy and securing the information you provide when booking flights through our platform. We understand the importance of data security in today's digital landscape. The information below outlines how we handle and protect your personal details. You have full control over the information you choose to share with us, though some of our flight booking services may require certain details to function properly.
          </p>

          <div className="terms-section">
            <h2>When we collect your information:</h2>
            
            <div className="booking-section">
              <ol>
                <li>When you book or reserve flights through our platform.</li>
                <li>When you submit a flight inquiry or request a quote.</li>
                <li>When you provide feedback about our website or services.</li>
                <li>When you sign up for our flight deal alerts and newsletters.</li>
                <li>When you register for promotional emails about flight specials.</li>
                <li>When you participate in our customer experience surveys.</li>
                <li>When you apply for employment opportunities with us.</li>
              </ol>
            </div>

            <div className="terms-subsection">
              <h3>Flight Deal Alerts and Promotional Emails</h3>
              <p>
                If you subscribe to receive flight deal alerts from Click4Flight, we will maintain your email address and send you information about flight specials, promotions, and travel opportunities. You can unsubscribe at any time using the opt-out link in every email we send, or by managing your preferences in your account settings.
              </p>
            </div>

            <div className="terms-subsection">
              <h3>Technical Information Collection</h3>
              <p>
                We gather technical data about your device when you visit our website, including your IP address, operating system, browser type, screen resolution, and referral source. This information is collected separately from your personal details and is never linked to your individual identity. We use this technical data solely to optimize our website performance and enhance your browsing experience.
              </p>
            </div>

            <div className="terms-subsection">
              <h3>How We Utilize Your Information</h3>
              <h4>Flight Booking Processing</h4>
              <p>
                When you book flights with Click4Flight, we securely store the information you provide to process, manage, and document your reservation. You will receive email confirmation of your booking shortly after completion. We may contact you by phone if necessary to fulfill the services you've requested or to clarify booking details.
              </p>
              <p>
                To provide the flight services you request, we may share necessary information with airline partners, payment processors, and other service providers. These third parties may be located outside your home country, but we ensure they maintain appropriate data protection standards.
              </p>
              
              <h4>Flight Inquiries and Quotes</h4>
              <p>
                When you submit a flight inquiry through our website forms, we use the provided information to generate accurate flight quotes and options. You can expect to receive follow-up communication via email or phone regarding your inquiry.
              </p>
              
              <h4>Customer Feedback and Surveys</h4>
              <p>
                Any feedback you provide about our services helps us improve our platform and offerings. We may contact you to discuss your feedback in more detail to better understand your experience.
              </p>
              <p>
                If you choose to participate in our surveys, the information collected is used only for analytical and improvement purposes. Your individual responses remain confidential and are not personally identifiable in our analysis.
              </p>
              
              <h4>Flight Promotion Communications</h4>
              <p>
                When you subscribe to receive flight deal emails, we use your information exclusively to send you relevant flight promotions and travel opportunities. Your subscription details are not used for other purposes and are never shared with external marketing companies.
              </p>
            </div>

            <div className="terms-subsection">
              <h3>Information Security Measures</h3>
              <p>
                We implement robust security measures to protect your personal information from unauthorized access, alteration, or disclosure. All data you submit is handled with the utmost care and used only for the purposes outlined in this privacy policy. We employ industry-standard encryption and security protocols throughout our booking process.
              </p>
            </div>

            <div className="terms-subsection">
              <h3>External Website Links</h3>
              <p>
                Our website may contain links to airline websites, travel partners, and other third-party resources for your convenience. Please note that the content, privacy practices, and information handling of these external sites are not governed by Click4Flight's privacy policy. We recommend reviewing the privacy policies of any external sites you visit.
              </p>
            </div>

            <div className="terms-subsection">
              <h3>Employment Applications</h3>
              <p>
                Information submitted in response to job postings is used exclusively for recruitment and hiring purposes. We may contact applicants via phone or email regarding their submissions. Application information is not used for marketing or shared beyond our recruitment team.
              </p>
            </div>

            <div className="terms-subsection">
              <h3>Policy Updates and Changes</h3>
              <p>
                Click4Flight reserves the right to modify this privacy policy as needed to reflect changes in our practices, services, or legal requirements. The version of the policy in effect at the time you provide your information will govern how we handle that data. We encourage you to periodically review this policy for any updates.
              </p>
            </div>

            <div className="terms-subsection">
              <h3>Questions and Contact Information</h3>
              <p>
                Click4Flight welcomes your questions, comments, and suggestions regarding our privacy practices or any aspect of our flight booking services.
              </p>
              <p>
                If you have privacy-related inquiries or concerns, please contact us via email at info@click4flight.co.uk or by phone at 020 3355 7350  during our business hours.
              </p>
              <p>
                <strong>Email:</strong> info@click4flight.co.uk<br />
                <strong>Phone:</strong> 020 3355 7350  
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;